import { __assign } from "tslib";
import React from 'react';
import { Button } from '@material-ui/core';
export var ButtonColors;
(function (ButtonColors) {
    // eslint-disable-next-line no-unused-vars
    ButtonColors["INHERIT"] = "inherit";
    // eslint-disable-next-line no-unused-vars
    ButtonColors["DEFAULT"] = "default";
    // eslint-disable-next-line no-unused-vars
    ButtonColors["PRIMARY"] = "primary";
    // eslint-disable-next-line no-unused-vars
    ButtonColors["SECONDARY"] = "secondary";
})(ButtonColors || (ButtonColors = {}));
/**
 * MyButton.
 *
 * @param {ButtonProps} props button's props
 * @returns {React.FC<ButtonProps>} Button.
 */
export var MyButton = function (options) { return (React.createElement(Button, __assign({}, options.props, { onClick: function () { return !options.disabled && options.onClick && options.onClick(); }, disabled: !!options.disabled, color: options.color || ButtonColors.PRIMARY, className: options.className, "data-testid": options.testID, variant: 'contained' }), options.children)); };
//# sourceMappingURL=Button.js.map